module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-flow-02-d3aefb1fd88b82c6a8f15779d94d06bb.png";